// Deep-linkable tab selection for EntityDetails pages.
//
// The op-mod details pages hold their active tab in local state (CgUnderlineTabs
// is a controlled strip, not a router). Retired sub-routes still need somewhere
// to land, so they redirect to `?tab=<id>` on the details page and the page
// seeds its initial tab from the query string.
//
//   // routes
//   <Redirect to={withTabQuery(`/stock/installations/${id}`, 'final-emissions')} />
//
//   // page
//   const [activeTab, setActiveTab] = useState(
//     resolveTabFromSearch(location.search, TAB_IDS, TAB_INPUT_SOURCES),
//   );
//
// Unknown / missing / duplicated values fall back to `fallback`, so a stale
// bookmark can never render a page with no tab panel visible.

export const TAB_QUERY_PARAM = 'tab';

/**
 * Pick the tab id encoded in a location search string.
 *
 * @param {string} search  `location.search` (with or without the leading '?')
 * @param {string[]} validIds  the tab ids the page actually renders
 * @param {string} [fallback]  returned when the param is absent or unknown
 * @returns {string|undefined}
 */
export function resolveTabFromSearch(search, validIds = [], fallback = undefined) {
  if (!search || typeof search !== 'string') return fallback;
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const requested = params.get(TAB_QUERY_PARAM);
  if (!requested) return fallback;
  return validIds.includes(requested) ? requested : fallback;
}

/**
 * Append `?tab=<id>` to a pathname, preserving an existing query string.
 *
 * @param {string} pathname
 * @param {string} tabId
 * @returns {string}
 */
export function withTabQuery(pathname, tabId) {
  if (!tabId) return pathname;
  const separator = pathname.includes('?') ? '&' : '?';
  return `${pathname}${separator}${TAB_QUERY_PARAM}=${encodeURIComponent(tabId)}`;
}
